<div class="title">{{ question.getQuestion() | translate }}</div>
<div class="description">{{ "uk_customer_segmentation.intro_description" | translate }}</div>
<div class="questions">
	<mat-radio-group
		(change)="onRadioChange($event)"
		name="{{ question.getId() }}">
		@for (answer of question.getAnswers(); track answer) {
			<mat-radio-button
				value="{{ answer.getId() }}"
				class="questions__radio"
				[checked]="answer.isSelected()">
				<div class="questions__text">
					{{ answer.getAnswer() | translate }}
					<span class="questions__description">{{ answer.getLabel() + ".description" | translate }}</span>
				</div>
			</mat-radio-button>
		}
	</mat-radio-group>
</div>